export default "__VITE_ASSET__BeuzwqSw__"